import http from '@/assets/js/http'
import {
  baseSmile
} from '@/assets/js/base-url.js'


export default {
  namespaced: true,
  state: {
    searchLoading: false,
    apiUrl: `${baseSmile}/business-catelog/`,
    requestType: '', // 用于存储create当前申请的requestType
  },
  mutations: {
    setRequestType(state, newVal) {
      state.requestType = newVal
    },
    // setSuggestions(state, newVal) {
    //   state.bizFieldSuggestions = newVal
    // }
  },
  actions: {
    querySearchAsync(ctx, {
      queryString,
      callback = () => { }
    }) {
      return http.get(ctx.state.apiUrl, {
        business_field__icontains: queryString
      })
        .then(response => {
          // ctx.commit('setSuggestions', response.data)
          callback(response.data)
        })
        .catch(error => {
          console.error(error)
          callback([])
        })
    },
    debounceQuerySearch(ctx, {
      queryString,
      callback
    }) {
      clearTimeout(window._debounceTimer)
      window._debounceTimer = setTimeout(() => {
        ctx.dispatch('querySearchAsync', {
          queryString,
          callback
        })
      }, 1500)
    },
  },
  getters: {
    // relatedFieldList(state) {
    //   return state.bizFieldSuggestions.reduce((acc, obj) => {
    //     const transformItems = obj.technical_fields.map(item => ({
    //       id: item.id,
    //       end_user_field: item.end_user_field
    //     }))
    //     return acc.concat(transformItems)
    //   }, [])
    // }
  },
  modules: {}
}



// WEBPACK FOOTER //
// ./src/store/customer-code-application.js